/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';
import Skeleton from 'react-loading-skeleton';
import { Sale } from '../types';
import { CustomerCell } from './SalesTable';
import { FormattedNumber, FormattedMessage, FormattedDate } from 'components/i18n';
import SaleTimeline from './SaleTimeline';
import { DateTime } from 'luxon';
import { colors } from '@atlaskit/theme';

type Props = {
  sale?: Sale;
}

const Row = styled.div`
  display: flex;
  line-height: 1.75;
  flex-direction: row;
`;
const Label = styled.div`
    color: ${colors.subtleText()};
    flex: 0 0 20%;
    min-width: 180px;
    max-width: 240px;
`;

const SaleOverview: React.FC<Props> = ({sale}) => {
  if(!sale) {
    return <Skeleton  />
  }
  return (
    <div>
        <CustomerCell customer={sale.customer}/>
      {(sale.status==='unpaid' || sale.status==='partiallypaid') &&
      <div css={css`margin-top: 1rem;`}>
        {/*<Row>*/}
        {/*  <Label><FormattedMessage id='sale.SaleOverview.totalAmount'  defaultMessage='Total amount'/></Label>*/}
        {/*  <div><FormattedNumber value={sale.totalAmount!} style="currency" currency="EUR"/></div>*/}
        {/*</Row>*/}
        <Row>
          <Label><FormattedMessage id='sale.SaleOverview.amountDue'  defaultMessage='Amount due'/></Label>
          <div><FormattedNumber value={sale.amountDue!} style="currency" currency="EUR"/></div>
        </Row>
        {/*<Row>*/}
        {/*  <Label><FormattedMessage id='sale.SaleOverview.invoiceDate'  defaultMessage='Invoice date'/></Label>*/}
        {/*  <div><FormattedDate value={sale.invoiceDate!}/></div>*/}
        {/*</Row>*/}
        <Row>
        <Label>
          <FormattedMessage
            id='sale.SaleOverview.daysOpen'
            defaultMessage='Days open'
          /></Label>
        <div>{Math.round(DateTime.local().diff(
          DateTime.fromISO(sale.invoiceDate!),
          'days'
          ).days)}
        </div>
        </Row>
        <Row>
          <Label><FormattedMessage id='sale.SaleOverview.dueDate'  defaultMessage='Due date'/></Label>
          <div><FormattedDate value={sale.dueDate!}/></div>
        </Row>
      </div>}
      <SaleTimeline events={sale.events} payments={sale.paymentList}/>
    </div>
  );
};

export default SaleOverview;
